import React from "react";
import { Col, Row } from "antd";

import BoxSectionItem from "../../../../../../../components/box-section/box-section-item";
import { DateHelper, StringHelper } from "../../../../../../../helper";

interface Props {
  data: any;
}

export const AccidentNotificationDetail = ({ data }: Props) => {
  return (
    <Row gutter={[32, 0]}>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Họ và tên" textRight={data?.eRequestName} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Mã nhân viên" textRight={data?.eEmployeeId} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Cơ quan/Đơn vị"
          textRight={
            StringHelper.verticalBarSplit<string[]>(data?.eDepartment)[1]
          }
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Phòng"
          textRight={StringHelper.verticalBarSplit<string[]>(data?.eUnit)[1]}
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Đội"
          textRight={StringHelper.verticalBarSplit<string[]>(data?.eTeam)[1]}
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Thời gian tai nạn"
          textRight={DateHelper.formatDateToString(data?.eAccidentTime)}
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Địa điểm tai nạn"
          textRight={data?.eAccidentLocation}
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Tình trạng" textRight={data?.eStatus} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Lý do tai nạn" textRight={data?.eReason} />
      </Col>
    </Row>
  );
};
